// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Success2: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M16.9 46.6L2.2 28c-.2-.3-.2-.7.1-.9l1.2-.9c.2-.2.6-.2.8.1l12.6 15.9L46 4.9c.2-.3.6-.3.8-.1l1.2 1c.3.2.3.6.1.8l-31.2 40z"/></svg>;
};

export default React.memo(Success2);
